import LocationMap from '@watermarkchurch/location-map'
import React from 'react'
import WCC from 'wcc'
import aa, {InsightsClient} from '../lib/components/algolia-search/insights'
import { ListItem } from '../lib/components/location-map/list-item'
import { Configure, InstantSearch } from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'

import connectGoogleMaps from '../lib/connectors/googleMaps'
import { ITranslationsProvided, withTranslations } from '../lib/connectors/translation'

interface IProps {
  domainObject: {
    id: string;
    title: string;
    type: string;
  },
  indexName: string,
  virtualEventsIndex?: string,
  includeVirtualEvents?: boolean
}

const ConnectedLocationMap = connectGoogleMaps(LocationMap)

const searchClient = algoliasearch(
  WCC.CONSTANTS?.ALGOLIA_APP_ID || 'server-rendering',
  WCC.CONSTANTS?.ALGOLIA_SEARCH_API_KEY || 'server-rendering'
)

export default withTranslations(({t, translationsAt: _, domainObject, indexName, virtualEventsIndex, includeVirtualEvents}: IProps & ITranslationsProvided) =>
  <InstantSearch
    searchClient={searchClient}
    indexName={indexName}
  >
    <Configure aroundRadius={40000} />
    <ConnectedLocationMap
      domainObject={domainObject}
      indexName={indexName}
      virtualEventsIndex={virtualEventsIndex}
      includeVirtualEvents={includeVirtualEvents}
      algoliaApiKey={WCC.CONSTANTS?.ALGOLIA_SEARCH_API_KEY || 'server-rendering'}
      algoliaAppId={WCC.CONSTANTS?.ALGOLIA_APP_ID || 'server-rendering'}
      translate={t}
      aa={aa as InsightsClient}
      ListItem={ListItem} />
  </InstantSearch>,
)
